"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var ConnectToDialogStyles_1 = require("../style/ConnectToDialogStyles");
var ConnectToRowDisabledWarning = /** @class */ (function (_super) {
    __extends(ConnectToRowDisabledWarning, _super);
    function ConnectToRowDisabledWarning() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConnectToRowDisabledWarning.prototype.render = function () {
        // Show default warning message about connecting to the data not supported.
        // This will be the case for unsupported databases, tables and data sources (including cube data sources).
        var unsupportedRowWarningText = Localize_1.Messages.ConnectToUnsupportedRowWarningTextDefault();
        // Show warning message about not having permissions to connect to the data only for data sources,
        // and only when the data source is supported but user doesn't have permission to connect to it.
        if (this.props.isDatasourceSupported != null && this.props.doesDatasourceHaveConnectPermission != null
            && this.props.isDatasourceSupported && !this.props.doesDatasourceHaveConnectPermission) {
            unsupportedRowWarningText = Localize_1.Messages.ConnectToUnsupportedRowWarningTextNoConnectPermission();
        }
        return (React.createElement("div", { className: typestyle_1.classes(ConnectToDialogStyles_1.ConnectToDialogRowDisabledWarningContainer), role: 'alert', "data-tb-test-id": 'connect-to-dialog-row-disabled-warning-container' }, unsupportedRowWarningText));
    };
    return ConnectToRowDisabledWarning;
}(React.PureComponent));
exports.ConnectToRowDisabledWarning = ConnectToRowDisabledWarning;
//# sourceMappingURL=ConnectToRowDisabledWarning.js.map